export default "__VITE_ASSET__B$fjRC$w__"